import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { defineLocale } from "ngx-bootstrap/chronos";
import {
  BsDatepickerConfig,
  BsDatepickerDirective,
  BsLocaleService,
} from "ngx-bootstrap/datepicker";
import { deLocale, enGbLocale } from "ngx-bootstrap/locale";
import { DropdownComponent } from "../components/dropdown/dropdown.component";
import { AppointmentType, Doctor } from "../widget.model";

enGbLocale.longDateFormat.L = "MM/DD/YYYY";

defineLocale("de", deLocale);
defineLocale("en", enGbLocale);

@Component({
  selector: "step-one",
  templateUrl: "./step-one.component.html",
  styleUrls: ["./step-one.component.scss"],
})
export class StepOneComponent implements OnInit, OnChanges {
  @Input() appointmentTypeList: AppointmentType[];
  @Input() stepTwo: boolean;
  @Input() preselectedAppointmentType: AppointmentType;
  @Input() doctorList: Doctor[];
  @Input() shouldResetForm: boolean;

  @Output() getPotentialAppointments = new EventEmitter();
  @Output() getDateFromDatepicker = new EventEmitter();
  @Output() getSelectedAppointmentTypeUid = new EventEmitter();

  @ViewChild(DropdownComponent)
  dropdown: DropdownComponent;

  private _picker: BsDatepickerDirective;
  bsConfig: Partial<BsDatepickerConfig>;
  selectedDate: Date = null;
  todaysDay: Date = new Date();
  selectedAppointmentTypeUid: string = null;
  selectedDoctorId: string = null;
  shouldResetSelectedValue: boolean;

  constructor(private localeService: BsLocaleService) {
    this.localeService.use("de");
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes.shouldResetForm &&
      changes.shouldResetForm.currentValue
    ) {
      this.resetForm();
    }
  }

  ngOnInit() {
    this.bsConfig = Object.assign(
      {},
      { showWeekNumbers: false, minDate: this.todaysDay, isDisabled: true }
    );
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if (
        isHovered &&
        !!navigator.platform &&
        /iPad|iPhone|iPod/.test(navigator.platform) &&
        "ontouchstart" in window
      ) {
        (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
      }

      return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }

  onSelectAppointmentType(option: string) {
    this.selectedAppointmentTypeUid = option;
    this.getSelectedAppointmentTypeUid.next(option);
    this.getAppointments();
  }

  onSelectDoctor(option: string) {
    this.selectedDoctorId = option;
    this.getAppointments();
  }

  onDateChange(date: Date) {
    this.selectedDate = date;
    this.getDateFromDatepicker.next(date);
    this.getAppointments();
  }

  getAppointments() {
    if (this.preselectedAppointmentType) {
      this.selectedAppointmentTypeUid = this.preselectedAppointmentType.uid;
    }
    if (this.selectedDate && this.selectedAppointmentTypeUid) {
      this.getPotentialAppointments.next({
        date: this.selectedDate,
        appointmentTypeUid: this.selectedAppointmentTypeUid,
        doctorId: this.selectedDoctorId,
      });
    }
  }

  resetForm() {
    this.selectedDate = null;
    this.selectedAppointmentTypeUid = null;
    this.selectedDoctorId = null;
    this.shouldResetSelectedValue = true;
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/step-one/step-one.component.ts